import {ColumnMain} from "#/models/column-main";
import {Column} from "#/models/column";
import {Trans} from "@lingui/macro";
import React from "react";

const DdsRequirementModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();
    
    columns.push({key:'id', width: 80, filter:true, sorter:true, title:<Trans>ID</Trans>});
    columns.push({key:'ddsAssignmentRule.ddsNumber', dataIndex: ['ddsAssignmentRule', 'ddsNumber'], width: 200, filter:true, sorter:true, title:<Trans>DDS Number</Trans>});
    columns.push({key:'status', width: 150, filter:true, sorter:true, title:<Trans>Status</Trans>});
    columns.push({key:'numberOfTrials', width: 150, filter:true, sorter:true, title:<Trans>Number Of Trials</Trans>});
    columns.push({key:'updatedDate', width: 180, dateTimeFilter:true, sorter:true, title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 150, filter:true, sorter:true, title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 180, dateTimeFilter:true, sorter:true, title:<Trans>Created Date</Trans>, direction:"desc"});
    columns.push({key:'createdBy', width: 150, filter:true, sorter:true, title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/dds-requirements"
    };

}
export default DdsRequirementModel();

